import { useEffect, useState, useCallback } from "react";
import { api, errMsg } from "@/lib/api";
import { PageHeader, Loading, ErrorState, EmptyState, StatCard } from "@/components/common";
import { Card, CardContent } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Clock, Stethoscope, CheckCircle2 } from "lucide-react";

export default function AdminAssistance() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    setLoading(true); setError("");
    try { setData(await api.adminAssistance()); }
    catch (e) { setError(errMsg(e)); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  if (loading) return <Loading />;
  if (error) return <ErrorState message={error} onRetry={load} />;

  const d = data || {};
  const rows = Array.isArray(d.physios) ? d.physios : [];
  const totals = d.totals || {};

  return (
    <div>
      <PageHeader title="Minuti assistenziali" subtitle={`Periodo ${d.period || ""} · ${d.from || ""} → ${d.to || ""}`} />
      <div className="mb-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <StatCard icon={Clock} label="Prescritti (tot)" value={totals.prescribed_minutes ?? 0} testId="admin-prescribed" />
        <StatCard icon={CheckCircle2} label="Eseguiti (tot)" value={totals.executed_minutes ?? 0} tint="accent" testId="admin-executed" />
        <StatCard icon={Stethoscope} label="Fisioterapisti" value={rows.length || "—"} testId="admin-physio-count" />
      </div>

      {rows.length === 0 ? <EmptyState title="Nessun dato di assistenza" /> : (
        <Card className="border-border/70">
          <CardContent className="p-0">
            <Table data-testid="admin-assistance-table">
              <TableHeader>
                <TableRow>
                  <TableHead>Fisioterapista</TableHead>
                  <TableHead className="text-right">Prescritti (min)</TableHead>
                  <TableHead className="text-right">Eseguiti (min)</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {rows.map((r, i) => (
                  <TableRow key={r.physio_id || i}>
                    <TableCell className="font-medium">{r.physio_name || r.physio_id}</TableCell>
                    <TableCell className="text-right">{r.prescribed_minutes ?? 0}</TableCell>
                    <TableCell className="text-right">{r.executed_minutes ?? 0}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      )}
    </div>
  );
}
